import { Helpers } from '../../helpers';
import { IConstructionType } from '../../interfaces/iconstruction-type';
import { Project } from '../project';
import { ProjectTemplate } from '../project-template';
import { StandardConfigurationConstructionType } from '../standard-configuration-construction-type';

export class ConstructionTypeBase {
  ConstructionTypeId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Projects_ConstructionType?: Array<Project> | null;
  ProjectTemplates_ConstructionType?: Array<ProjectTemplate> | null;
  StandardConfigurationConstructionTypes_ConstructionType?: Array<StandardConfigurationConstructionType> | null;

  constructor(item?: IConstructionType) {
    if (item) {

      this.ConstructionTypeId = item.ConstructionTypeId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Projects_ConstructionType = Helpers.createClassArray(Project, item.Projects_ConstructionType);
      this.ProjectTemplates_ConstructionType = Helpers.createClassArray(ProjectTemplate, item.ProjectTemplates_ConstructionType);
      this.StandardConfigurationConstructionTypes_ConstructionType = Helpers.createClassArray(StandardConfigurationConstructionType, item.StandardConfigurationConstructionTypes_ConstructionType);
    }
  }
}